import React from 'react';
import { observer } from 'mobx-react';
import ExistOldLoginComponent from './Exist-old-login.component';
import useExistOldLogin from './useExistOldLogin';
import { ICloseEvent } from '@core/interfaces/ICloseEvent';

const Container: React.FC<ICloseEvent> = ({ onClose }: ICloseEvent) => {
    const { lang, user, handlers, devices } = useExistOldLogin(onClose);
    return (
        <>
            <ExistOldLoginComponent
                loading={user.loading} 
                loadold={devices.loading}               
                lang={lang.lang}
                loginactive={user.loginActive}
                onSignInClick={handlers.handleSignInClick}
                onBtnKeyDown={handlers.handleBtnKeyDown}
                onClose={onClose}
            />
        </>
    );    
};

const ExistOldLoginContainer = observer(Container);

export default ExistOldLoginContainer;
